const { ethers } = require("ethers");

const RPC_URL = "https://bsc-dataseed.binance.org";

const ERC20_ABI = [
  "function decimals() view returns (uint8)"
];

export async function getActiveTotalStake(
  userAddress,
  contractAddress,
  version
) {
  const provider = new ethers.providers.JsonRpcProvider(RPC_URL);

  const ABI = [
    `function userDepositCountsV${version}(address) view returns (uint256)`,
    `function userDepositIdsV${version}(address, uint256) view returns (uint256)`,
    `function depositInfoV${version}(uint256) view returns (
      uint256 depositId,
      address alloteeAddress,
      uint256 depositedAmount,
      uint256 releasePercentage,
      uint256 recurringTimePeriodInDays,
      uint256 depositedTimestamp,
      uint256 maturityTimestamp,
      uint256 timePeriodInDays
    )`,
    "function token() view returns (address)",
  ];

  const contract = new ethers.Contract(contractAddress, ABI, provider);

  let decimals = 18;

  try {
    const tokenAddr = await contract.token();
    const tokenContract = new ethers.Contract(tokenAddr, ERC20_ABI, provider);
    decimals = await tokenContract.decimals();
  } catch {
    // default to 18
  }

  const count = Number(
    await contract[`userDepositCountsV${version}`](userAddress)
  );

  const now = Math.floor(Date.now() / 1000);
  let activeStake = ethers.BigNumber.from(0);

  for (let i = 0; i < count; i++) {
    const depositId = await contract[`userDepositIdsV${version}`](
      userAddress,
      i
    );

    const deposit = await contract[`depositInfoV${version}`](depositId);

    if (now < Number(deposit.maturityTimestamp)) {
      activeStake = activeStake.add(deposit.depositedAmount);
    }
  }

  return Number(ethers.utils.formatUnits(activeStake, decimals));
}